import routes from './routes.json';

/* מקור האמת לתגיות ה-head של כל ראוט הוא src/seo/routes.json -
   אותו קובץ נקרא גם על ידי scripts/postbuild-seo.js שמייצר את
   build/course/index.html עבור זחלנים שלא מריצים JavaScript. */

export const SITE_URL = routes.site.url;
export const SITE_NAME = routes.site.name;
export const PHONE = routes.site.phone;
export const EMAIL = routes.site.email;
export const ORGANIZATION = routes.business;

function toSeo(route) {
  return {
    title: route.title,
    description: route.description,
    keywords: route.keywords,
    canonical: route.canonical,
    url: route.canonical,
    image: route.image,
    siteName: SITE_NAME,
  };
}

export const HOME_SEO = toSeo(routes.home);
export const COURSE_SEO = toSeo(routes.course);

/** גרף הנתונים המובנים של עמוד הקורס, כולל שאלות נפוצות מתוך data/faq.js */
export function buildCourseJsonLd(faqItems = []) {
  const graph = [...routes.course.jsonLd, ORGANIZATION];

  if (faqItems.length) {
    graph.push({
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    });
  }

  return { '@context': 'https://schema.org', '@graph': graph };
}
